import { render } from "./ObjectList.vue?vue&type=template&id=5fbfa56a"
import script from "./ObjectList.vue?vue&type=script&lang=js"
export * from "./ObjectList.vue?vue&type=script&lang=js"

import "./ObjectList.vue?vue&type=style&index=0&id=5fbfa56a&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.5.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__